import { FirebaseContext } from "../context/firebaseContext";
import { useContext, useEffect } from "react";
import { useDispatch } from "react-redux";
import { logoutAsync } from "../features/auth/authSlice";
import { clearUserAsync } from "../features/user/userSlice";
import { clearContentAsync } from "../features/content/contentSlice";
import { clearMapAsync } from "../features/map/mapSlice";
import { clearNotificationsAsync } from "../features/notifications/notificationsSlice";
import { clearLightboxVideoAsync } from "../features/ui/uiSlice";

import AMDGoogleCloudLogo from "../images/logos/AMDGoogleCloudLogo";
import EPYCExplorerLogo from "../images/logos/EPYCExplorerLogo";

import ShutdownNotice from "../components/shutdown/ShutdownNotice";

import "../styles/screens/Welcome.scss";

const handleLogout = async ({ dispatch, firebase }) => {
  try {
    await dispatch(logoutAsync({ auth: firebase.auth }));
    await dispatch(clearUserAsync());
    await dispatch(clearContentAsync());
    await dispatch(clearMapAsync());
    await dispatch(clearNotificationsAsync());
    await dispatch(clearLightboxVideoAsync());    
  } catch (error) {
    console.error("Error during logout:", error);
  }
};

export default function WelcomeScreen(props) {
  const firebase = useContext(FirebaseContext);
  const dispatch = useDispatch();

  useEffect(() => {
    if (firebase && firebase.auth) {
      handleLogout({ dispatch, firebase })
    }
  }, [dispatch, firebase])

  return (
    <section className="Welcome">
      <div className="container">
        <div className="logos">
          <AMDGoogleCloudLogo />
          <EPYCExplorerLogo />
        </div>

        <ShutdownNotice />
      </div>
    </section>
  );
}
